var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParedes = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 124,
  height: 110,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M82.953-1h-8.27l13.12 33.884 35.512-14.872L82.953-1z",
  fill: "#079D56"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M87.804 32.884l29.579 76.326 5.943-3.585V18.024l-.011-.012-35.511 14.872z",
  fill: "#006B3F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.683-1H.463v88.11h74.22V-1z",
  fill: "#D7D8D6"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M74.683-1H.463v88.11h74.22V-1z",
  fill: "url(#paint0_linear)"
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M74.683-1l42.7 21.394v88.816l-42.7-22.1V-1z",
  fill: "#00D38D"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.77,
  d: "M74.683-1l42.7 21.394v88.816l-42.7-22.1V-1z",
  fill: "url(#paint1_linear)"
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.573 52.105v5.47h32.418l-6.793-5.47H21.573z",
  fill: "#727D79"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M54.142 26.246h-6.944v25.859l6.792 5.47h.152V26.245z",
  fill: "#ACACAC"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M47.198 26.246H21.573v25.859h25.625V26.245zM89.595 33.509v24.204l17.447 9.125V42.645l-17.447-9.136z",
  fill: "#fff"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M89.595 33.509l-5.502-2.868v28.923l5.502-2.001V33.509z",
  fill: "#079D56"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M89.595 57.713v-.15l-5.502 2v.012l22.949 12.004v-4.741l-17.447-9.125z",
  fill: "#006B3F"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M6.662 86.96h67.742l42.7 22.1",
  fill: "url(#paint2_linear)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0.462,
  y1: 43.049,
  x2: 74.683,
  y2: 43.049,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 74.683,
  y1: 54.105,
  x2: 117.383,
  y2: 54.105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 117.104,
  y1: 98.016,
  x2: 6.662,
  y2: 98.016,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgParedes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paredes.c5aac1d5e58526751b12100533754a5c.svg";